import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { HeaderIconContainer, LinkNoDecoration } from 'components/app-header/styled';
import { VisuallyHidden } from 'components/ucl/visually-hidden';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useReactNavigationFlag } from 'hooks/use-react-navigation-flag';
import { portalToHeader } from 'state/mobile-header-nav';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

interface BackArrowLinkProps {
  to: string;
}
const PortalBackArrowLink: React.VFC<BackArrowLinkProps> = portalToHeader(({ to }) => {
  const { formatMessage } = useIntl();

  return (
    <LinkNoDecoration to={to}>
      <StyledBackIcon variant="back" />
      <VisuallyHidden accessibilityLabel={formatMessage({ id: 'back' })} />
    </LinkNoDecoration>
  );
});
export const BackArrowLink: React.VFC<BackArrowLinkProps> = props => {
  const enabledReactNativeNavigation = useReactNavigationFlag();
  return enabledReactNativeNavigation ? null : <PortalBackArrowLink {...props} />;
};

interface BackArrowHistoryProps {
  onPress?: () => void;
  icon?: React.ReactNode;
}
export const PortalBackArrowHistory: React.VFC<BackArrowHistoryProps> = portalToHeader(
  ({ onPress, icon = <StyledBackIcon variant="back" /> }) => {
    const { formatMessage } = useIntl();
    const { goBack } = useNavigation();
    const onPressBack = () => goBack();
    const backButtonLabel = formatMessage({ id: 'back' });

    return (
      <HeaderIconContainer
        testID="back-arrow-history"
        onPress={onPress || onPressBack}
        accessibilityLabel={backButtonLabel}
        accessibilityRole="button"
      >
        {icon}
        <VisuallyHidden accessibilityLabel={backButtonLabel} />
      </HeaderIconContainer>
    );
  }
);
export const BackArrowHistory: React.VFC<BackArrowHistoryProps> = props => {
  const enabledReactNativeNavigation = useReactNavigationFlag();
  return enabledReactNativeNavigation ? null : <PortalBackArrowHistory {...props} />;
};
